<template>
  <div>
    <load-content :loading="isBusyCoderProfile">
          <div class="article-group-container">
            <a href="javascript:window.history.back();">
              <button class="btn-link-art"> ⟵ Back </button>
            </a>
          </div>
          <div id="side-panel-content" v-if="this.options.length > 0">
              <div class="containter-profile">
                <form class="form-side-panel card">
                  <div class="form__group field">
                    <input
                      v-if="coderProfile.name"
                      type="input"
                      class="form__field"
                      placeholder="Name"
                      name="name"
                      id="name"
                      readonly
                      v-model="coderProfile.name"
                    />
                    <input v-else class="form__field" type="input" readonly value="N/A"/>
                    <label for="name" class="form__label">Name</label>
                  </div>
                  <div class="form__group field">
                    <input
                      v-if="coderProfile.articles"
                      type="input"
                      class="form__field"
                      placeholder="Articles"
                      name="articles"
                      id="articles"
                      readonly
                      v-model="coderProfile.articles"
                    />
                    <input v-else class="form__field" type="input" readonly value="N/A"/>
                    <label for="articles" class="form__label">Assigned Articles</label>
                  </div>
                  <div class="form__group field">
                    <input
                      v-if="this.coderLastCoded"
                      type="input"
                      class="form__field"
                      placeholder="Last Coded"
                      name="last_coded"
                      id="last_coded"
                      readonly
                      v-model="this.coderLastCoded"
                    />
                    <input v-else class="form__field" type="input" readonly value="N/A"/>
                    <label for="last_coded" class="form__label">Last Coded</label>
                  </div>
                  <div class="select-div">
                    <label class="available">Availability</label>
                    <input-select
                        name="available"
                        ref="available"
                        :allowEmpty="false"
                        :selectedValue="coderProfile.available"
                        :options="options"
                        :onChange="updateSelect"
                      />
                  </div>
                  <div
                    v-if="coderProfile.available"
                    class="select-div"
                  >
                    <label class="available">Available Dates</label>
                       <articles-filter-date
                          title="Date Range: "
                          :value="filtersDateRange"
                          :onChange="onChangeDateFilters"
                        />
                  </div>
                  <div class="select-div">
                    <label class="available">Languages</label>
                     <input-select
                        name="languages"
                        ref="languages"
                        :selectedValue="coderProfile.languages"
                        :options="optionsLanguages"
                        :multiple="true"
                        :searchable="true"
                        :onChange="updateLanguage"
                      />
                  </div>
                </form>
                <form class="form-list card">
                  <div>
                    <h3>List of Associated Projects</h3>
                  </div>
                  <datatable ref="table" v-if="isReady" :data="datatable"
                  />
                </form>
              </div>
          </div>

            <side-panel v-if="AddProjectOpen" :onClose="closeSidePanel">
              <div>
                <h3>Enable project to coder</h3>
                <div class="form form--sidepanel">
                  <div>
                    <div class="form-group">
                      <label for="projects">Projects</label>
                      <input-select
                        ref="project_id"
                        name="project_id"
                        :options="availableProjects"
                        :allowEmpty="false"
                        :preselectFirst="true"
                        :onChange="onInputChange"
                        :searchable="true"
                        :onSearchChange="onSearchChange"
                        :internalSearch="false"
                        placeholder="Select a project"
                        tagPlaceholder="Press enter to create a new Project"
                        :selectedValue="selectedProject"
                      />
                    </div>
                    <div class="form-group">
                      <button type="submit" class="btn btn-carma" @click="submitAddNewProject" :disabled="selectedProject == null">Add Project</button>
                    </div>
                  </div>
                </div>
              </div>
            </side-panel>
        </load-content>

        <side-panel v-if="showRemoveProject" :onClose="closeSidePanel">
          <template>
            <load-content :loading="isBusy">
              <confirm-delete
                :label="removeProjectObj.name"
                :title="'messages.confirm_delete.title_project_from_coder'"
                :message="'messages.confirm_delete.message_remove'"
                :deleteButtonLabel="'remove'"
                :onDelete="() => RemoveProjectFromCoder(removeProjectObj)"
              />
            </load-content>
          </template>
        </side-panel>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { USER_PERMISSIONS } from '../../config/const';
import Datatable from '../../components/datatable';
import Moment from 'moment';
import _ from "lodash";
import InputSelect from "../../components/form-components/input-select"
import ArticlesFilterDate from "../../components/coding-admin/articles-filter-date";
import CountriesList from 'countries-list';
import LoadContent from '../../components/load-content';
import CodingHeadline from '../../components/coding-headline';
import Vue from 'vue';
import { inputErrors } from "../../helpers/inputErrorHelper";
import SidePanel from '../../components/side-panel';
import ConfirmDelete from "../../components/confirm-delete";

const dateFormat = "YYYY-MM-DD";

export default {
  name: 'ProjectCoderProfile',
    components: {
    LoadContent,
    Datatable,
    InputSelect,
    SidePanel,
    ConfirmDelete,
    ArticlesFilterDate
  },
  data: function() {
    const { CODER_HOME_SCREEN } = USER_PERMISSIONS;
    return {
      coderInfo: {},
      coderLastCoded: '',
      //coderLanguages: '',
      isReady: false,
      datatable: {},
      options: [],
      optionsLanguages: [],
      CODER_HOME_SCREEN,
      formErrors: null,
      AddProjectOpen: false,
      selectedProject: null,
      pagination: {
        page: 1,
        perPage: 20,
        order: 'project_name',
        sort: 'asc'
      },
      available_projects_pagination: {
        page: 1,
        perPage: 20,
        order: 'project_name',
        sort: 'asc'
      },
      fakeData: {},
      showRemoveProject: false,
      removeProjectObj: {}
    }
  },

  computed: {
    ...mapState({
      user: state => state.user.user.data ? state.user.user.data : {},
      project: state => state.projects.project.data ? state.projects.project.data : [],
      projects: state => state.projects.projects.data ? state.projects.projects.data : [],
      coders: state => state.articles.coders.data ? state.articles.coders.data : [],
      isBusy: state => state.articles.articles.isBusy,
      isBusyCoderProfile: state => state.coders.coderProfile.isBusy,
      coderProjects: state => state.projects.coderProjects.data ? state.projects.coderProjects.data : [],
      coderProfile: state => state.coders.coderProfile.data ? state.coders.coderProfile.data : {},
    }),
      projectsCoder: {
        get () {
          return this.coderProjects;
        }
      },
      filtersDateRange() {
        return {
          from: Moment(this.coderProfile.available_from).isValid() == false || Moment(this.coderProfile.available_from) == (null || undefined) ? null : Moment(this.coderProfile.available_from).format('YYYY-MM-DD'),
          to: Moment(this.coderProfile.available_to).isValid() == false || Moment(this.coderProfile.available_to) == (null || undefined) ? null : Moment(this.coderProfile.available_to).format('YYYY-MM-DD')
      };
    },
    availableProjects() {
      return this.projects.data.map(p => ({ value: p.project_id, label: p.project_name }));
    },
    coderId() {
      return this.$route.params.coder_id;
    }
  },

    watch: {
    "coderProjects": {
      handler: function(newValue) {
        const data = this.datatable;
        this.datatable = Object.assign({}, data, { body: newValue });
        this.getCoderInfos();
      },
      deep: true
    },
    coderProfile: {
      handler(value) {
        // this.$emit('setHeaderSecondaryName', value.name);
      }
    },
    filtersDateRange: {
      handler(value) {
        return {
          from: Moment(value.from).isValid() == false || Moment(value.from) == (null || undefined) ? null : Moment(value.from).toDate(),
          to: Moment(value.to).isValid() == false || Moment(value.to) == (null || undefined) ? null : Moment(value.to).toDate()
      };
      }
    },
    formErrors: {
      handler(value){
         value && import('vue').then(v => {
            v.default.notify({
              group: "store_notifications",
              type: "error",
              text: value
            })
          });
      },
      deep: true
    }
  },

  mounted() {
    const { coderId } = this;
    this.fetch();

    this.getCoderProfile({ coderId });
    this.getCoderProjects({ coderId });

     this.isReady = true;
     const self = this;
     this.datatable = {
      custom_components: {
          'coding-headline': CodingHeadline
        },
      columns: [
        {
          key: 'name',
          label: 'Projects',
          style: { 'min-width': '300px' },
          input: {
            name: 'name',
            component: {
              name: 'coding-headline',
              getProps: function(row) {
                const projectsInfo = { ...row};
                return {
                  ...row,
                  onClick: function(id) {
                    const projectUrl = `/analysis/projects/${id}/coders/${coderId}/articles`;
                    self.$router.push(projectUrl);
                  },
                }
              }
            },
          }
        },
     ],
      body: this.coderProjects,
      addRow: {
        enabled: true,
        label: "Add New Project",
        onClick: function() {
          self.openSidePanel();
        }
      },
      removeRow: {
        enabled: true,
        onClick: (row) => {
          this.showRemoveProject = true;
          return {
            ...this.removeProjectObj = row
          }
        }
      }
     }
  },

   methods: {
    ...mapActions({
      // getCoders: 'articles/getCoders',
      updateCoderProfile: 'articles/updateCoderProfile',
      refreshCoderProfile: 'coders/refreshCoderProfile',
      getCoderProjects: 'projects/getCoderProjects',
      getCoderProfile: 'coders/getCoderProfile',
      getAllProjects: 'projects/getAllProjects',
      getProjects: 'projects/getProjects',
      removeProjectFromCoder: 'projects/removeProjectFromCoder',
      addUserCoder: 'articles/addUserCoder',
      addCoderToProject: 'projects/addCoderToProject'
    }),
    onChangeDateFilters: function(from, to) {
      let payload = _.cloneDeep(this.coderInfo);

      from = from == null || Moment(from).isValid() == false ? '' : Moment(from).format(dateFormat);
      to = to == null || Moment(to).isValid() == false ? '' : Moment(to).format(dateFormat);

      payload.available_from = from;
      payload.available_to = to;

      const { coderId } = this;
      this.updateCoderProfile({ coderId, payload });
    },
    fetch: function() {
      let { pagination, coderId } = this;
      this.getProjects({ pagination });
      this.getCoderProjects({ coderId });
      this.getCoderProfile({ coderId })
    },
    RemoveProjectFromCoder(row) {
      this.getCoderInfos();
      const { coderId } = this;
      // const coder = this.coderInfo;
      const projectId = row.id;
      const index = this.coderProjects.findIndex(p => p.id == row.id);
      const removeProject = this.coderProjects[index];
      this.removeProjectFromCoder({ projectId, row: { id: coderId }, removeProject })
      this.showRemoveProject = false;
    },
    onSearchChange: function(value) {      
      let { pagination, coderId } = this;
      value !== '' && this.getProjects({ pagination, filters: { name: value, coderId } });
    },
    closeSidePanel: function() {
      this.AddProjectOpen = false;
      this.showRemoveProject = false;
      this.selectedProject = null;
    },
    openSidePanel: function() {
      this.AddProjectOpen = true;
      let { pagination , coderId} = this;
      this.getProjects({ pagination, filters: {coderId} });
    },
    onInputChange: function(value){
      this.selectedProject = value;
    },
    submitAddNewProject: function(){
      this.getCoderInfos();
      const { coderId } = this;
      const projectValue = this.selectedProject;
      const projectId = projectValue;
      const obj = {
        id: this.coderInfo.id,
        first_name: this.coderInfo.name,
        languages: this.coderInfo.languages,
        location_id: null,
      }
      this.addCoderToProject({ projectId, coderId, obj})
      this.closeSidePanel();
    },
    getCoderInfos: function() {
      const { coderId } = this;
      const coderIndex = this.coders.findIndex(c => c.id == coderId);

      this.coderInfo = this.coders[coderIndex] ? this.coders[coderIndex] : [];

      this.coderLastCoded = this.coderInfo.last_coded !== (null || undefined) ? Moment(this.coderInfo.last_coded).format('ll') : null;
      if (this.coderLastCoded == 'Invalid date') {
        this.coderLastCoded = 'N/A'
      }
      this.options = [
        { value: true, label: 'Available' },
        { value: false, label: 'Not Available' }
      ];

      const allLanguages = CountriesList.languages;
        this.optionsLanguages = Object.keys(allLanguages).map(key => {
          return {
            value: key,
            label: allLanguages[key].name
          }
        })
    },
    updateInput(valueInput) {
      this.formErrors = null;
      if (valueInput.name === "payment_rate") {
          this.formErrors = this.inputErrors(valueInput.value, "number", "Payment Rate");
      }
      if (valueInput.name === "rating") {
          this.formErrors = this.inputErrors(valueInput.value, "number", "Rating");
      }
      if (!this.formErrors) {
        let payload = _.cloneDeep(this.coderInfo);
        let inputName = valueInput.name;
        let inputValue = valueInput.value;
        payload[inputName] = inputValue;

        const { coderId } = this;
        this.updateCoderProfile({ coderId, payload });
      }
    },
    updateSelect(option) {
      let payload = _.cloneDeep(this.coderInfo);
      payload.available = option;
      const { coderId } = this;

      this.updateCoderProfile({ coderId, payload });
      this.refreshCoderProfile(payload);
    },
    updateLanguage(languages) {
      let payload = _.cloneDeep(this.coderInfo);
      payload.languages = languages;
      const { coderId } = this;
      this.updateCoderProfile({ coderId, payload });
    },
    inputErrors
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/components/coding-admin/coder_profile";
</style>